import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService, LoadingService } from 'ngx-kuv-tools';
import { TipoActualizacionService } from '../tipo-actualizacion.service';

@Component({
  selector: 'app-tipo-actualizacion-create',
  templateUrl: './tipo-actualizacion-create.component.html',
  styles: [
  ]
})
export class TipoActualizacionCreateComponent implements OnInit {

  form: FormGroup = new FormGroup({});

  constructor(
    public formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    public service: TipoActualizacionService,
    private loading: LoadingService,
    private alerts: AlertService
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      nombre: [null, [Validators.required]],
      descripcion: [null]
    });
  }

  guardar(): void {
    if (this.form.valid) {
      this.loading.show()
      this.service.insert(this.form.value).subscribe({
        next: (res: any) => {
          this.loading.hide();
          this.activeModal.close(res.model);
          this.alerts.addAlert("Tipo de Actualización registrado con éxito.", "success");
        },
        error: (err) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se pudo guardar el registro de tipo de actualización.", "danger");
          if (err.error.msg) {
            this.alerts.addAlert(err.error.msg, "danger");
          }
          if (err.error.errors[0]) {
            this.alerts.addAlert(err.error.errors[0].msg, "danger");
          }
        },
      })
    } else {
      this.form.markAllAsTouched();
      this.alerts.addAlert("Hay errores en el formulario.", "warning");
    }
  }

}
